// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  container: {
    marginBottom: theme.spacing(1),
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    cursor: 'pointer',
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  orderSelectRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
  },
  orderSelect: {
    fontWeight: 500,
    fontSize: '14px',
    textTransform: 'uppercase' as const,
    '.MuiSelect-select': {
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
      paddingRight: `${theme.spacing(3)} !important`,
    },
    '.MuiSelect-icon': {
      color: theme.palette.grey[600],
    },
  },
  headerRight: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  statusBadge: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    marginLeft: 'auto',
  },
  estimateDot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: '#F9A825',
  },
  processingDot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
  },
  completedDot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: '#4CAF50',
  },
  statusText: {
    fontSize: '13px',
    color: theme.palette.text.primary,
    fontWeight: 500,
  },
  content: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(1),
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  sectionTitle: {
    fontWeight: 600,
    fontSize: '13px',
    letterSpacing: '0.5px',
    textTransform: 'uppercase' as const,
  },
  datesRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    backgroundColor: '#F0F5F8',
    borderRadius: '6px',
    padding: theme.spacing(1.5),
  },
  dateLabel: {
    fontSize: '12px',
    color: theme.palette.grey[600],
    marginBottom: theme.spacing(0.5),
  },
  dateValue: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    fontSize: '13px',
  },
  dateIcon: {
    fontSize: '16px',
    color: theme.palette.grey[500],
  },
  dateIconHighlight: {
    fontSize: '16px',
    color: 'inherit',
  },
  dateValueHighlight: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    fontSize: '13px',
    color: theme.palette.primary.main,
  },
  dateTextHighlight: {
    color: 'inherit',
  },
  sectionLabel: {
    fontSize: '12px',
    color: theme.palette.grey[600],
    fontWeight: 500,
    marginBottom: theme.spacing(0.5),
    marginTop: theme.spacing(1),
  },
  productRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
  },
  productIcon: {
    fontSize: '16px',
    color: theme.palette.primary.main,
    backgroundColor: '#E8F4FA',
    borderRadius: '50%',
    padding: '4px',
    marginTop: '2px',
  },
  productName: {
    fontSize: '14px',
    fontWeight: 500,
  },
  layerCount: {
    fontSize: '12px',
    color: theme.palette.grey[600],
  },
  layerLink: {
    fontSize: '12px',
    color: theme.palette.primary.main,
    cursor: 'pointer',
    display: 'inline',
    textDecoration: 'underline',
  },
  chipsRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5),
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(1),
  },
  chip: {
    fontSize: '12px',
    height: '26px',
  },
  dataSetsHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing(1),
  },
  button: {
    padding: theme.spacing(0.5),
  },
});

export default styles;
